import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, Output, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { BsDatepickerDirective } from "ngx-bootstrap/datepicker";

@Component({
  selector: "date-picker",
  templateUrl: "./date-picker.component.html",
  styleUrls: ["./date-picker.component.scss"]
})

// HOW TO USE
// API TO DATEPICKER
// INPUT =>
//    defaultModel : default date
//    minDate : set mindate
//    maxDate : set maxdate
//    isDisabled : set disable
//    setOption :  setoption to datepicker
//      {
//        require : true, // is Require : true , not Require : false , OR not set is Require
//        table: false, // Datepicker from table
//        textAlign: "left" // text Align
//      }
// Output =>
//    defaultModelChange : return date change

// <date-picker [(defaultModel)]="date" ></date-picker> // default date and return value
// <date-picker [defaultModel]="date" (defaultModelChange)="func($event)" ></date-picker> // default date and return value to function
// <date-picker [minDate]="date"></date-picker> // set min date and not set default
// <date-picker [(defaultModel)]="date" [minDate]="date2"></date-picker> // default date and set min date
// <date-picker [(defaultModel)]="date" [minDate]="date2" [setOption]="{require:false}"></date-picker>

// HOW TO VALIDATE DATEPICKER

// Parent Component ViewChild by element to datepicker
//  <date-picker #startDate ></date-picker>

// TS FILE (Parent Component)
//   @ViewChild("startDate") startDatePicker: DatePickerComponent;
// and validate by
//  this.startDatePicker.myForm.controls["date"].markAsTouched(); => show text
//  this.startDatePicker.myForm.valid // have value or not

export class DatePickerComponent {
  myForm: FormGroup; // formGroup
  userCulture: string;
  constructor(
    private cdRef: ChangeDetectorRef
  ) {
    this.myForm = new FormGroup({
      date: new FormControl("", [Validators.required])
    });
  }

  minDate: Date; // variable mindate
  maxDate: Date; // variable maxdate
  isDisabled = false;
  @Output() readonly defaultModelChange = new EventEmitter<string>(); // return when date change

  originalDate: string;
  canChangeDate: boolean;

  // Set Min Date
  @Input("minDate")
  set setMinDate(value) {
    this.minDate = this.stringToDate(value);
  }
  get setMinDate(): any {
    return this.minDate;
  }

  // Set Max Date
  @Input("maxDate")
  set setMaxDate(value) {
    if (value) {
      const date = this.stringToDate(value);
      this.maxDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    }
  }

  @Input("isDisabled")
  set setIsDisable(value) {
    this.isDisabled = !value;
  }

  @Input("originalDate")
  set setOriginalDocDate(value) {
    this.originalDate = value;
    this.cdRef.detectChanges();
  }

  @Input("canChangeDate")
  set setCanChangeDocDate(value) {
    this.canChangeDate = value;
  }

  @Input() setOption = {
    require: true,
    table: false,
    textAlign: "left",
    color: false,
    showWeeks: false
  };

  // Set Default Date
  @Input()
  set defaultModel(value) {
    if (this.canChangeDate !== undefined) {
      if (this.canChangeDate) {
        this.myForm.controls["date"].setValue(this.stringToDate(value));
      } else {
        if (value) {
          this.myForm.controls["date"].setValue(this.originalDate);
        }
      }
    } else {
      this.myForm.controls["date"].setValue(this.stringToDate(value));
    }
    this.cdRef.detectChanges();
  }
  get defaultModel(): any {
    return this.myForm;
  }

  @ViewChild(BsDatepickerDirective) datepicker: BsDatepickerDirective; // Call Function In Bs Datepicker
  @HostListener("window:scroll") onScrollEvent(): any {
    this.datepicker.hide(); // Scroll Hide
  }

  onValueChange($event): any { // Value change return value to parent
    if ($event) {
      const dateChange = this.dateToString($event); // change date ot String
      this.defaultModelChange.emit(dateChange);
    } else {
      this.defaultModelChange.emit("");
    }
  }

  stringToDate(date: string): Date {
    if (date) {
      const dateArray = date.split("/"); // split date

      return new Date(parseInt(dateArray[2], 10), (parseInt(dateArray[1], 10) - 1), parseInt(dateArray[0], 10));
    }
  }

  dateToString(dateTime: Date): string {
    const day = ("0".concat(dateTime.getDate()
      .toString())).slice(-2);
    const month = ("0".concat((dateTime.getMonth() + 1).toString())).slice(-2);

    const year = dateTime.getFullYear()
      .toString();

    return day.concat("/")
      .concat(month)
      .concat("/")
      .concat(year);
  }

  onClear(): void {
    this.myForm.controls["date"].setValue("");
  }
}
